(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ditanto-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ditanto-slider')) {
    customElements.define('ditanto-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
        this.counter = this.querySelector('[data-slider-counter]');
        this.progress = this.querySelector('[data-slider-progress]');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.interval = Number(this.dataset.interval) || 7000;
        this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.querySelector('[data-slider-previous]')?.addEventListener('click', () => this.show(this.index - 1), { signal });
        this.querySelector('[data-slider-next]')?.addEventListener('click', () => this.show(this.index + 1), { signal });
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.sliderDot)), { signal }));
        this.addEventListener('mouseenter', () => this.pause(), { signal });
        this.addEventListener('mouseleave', () => this.resume(), { signal });
        this.addEventListener('focusin', () => this.pause(), { signal });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.resume();
        }, { signal });
        this.addEventListener('pointerdown', (event) => {
          this.pointerStart = event.clientX;
        }, { signal });
        this.addEventListener('pointerup', (event) => {
          if (this.pointerStart === undefined) return;
          const distance = event.clientX - this.pointerStart;
          this.pointerStart = undefined;
          if (Math.abs(distance) < 55) return;
          this.show(this.index + (distance < 0 ? 1 : -1));
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-slide]');
          const selectedIndex = this.slides.indexOf(slide);
          if (selectedIndex > -1) this.show(selectedIndex, false);
        }, { signal });
        document.addEventListener('visibilitychange', () => document.hidden ? this.pause() : this.resume(), { signal });
        this.show(this.index, false);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        window.clearTimeout(this.timer);
      }

      show(nextIndex, restart = true) {
        if (!this.slides.length) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
        this.dataset.activeTone = this.slides[this.index].dataset.tone;
        if (this.counter) this.counter.textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
        this.restartProgress();
        if (restart) this.schedule();
      }

      restartProgress() {
        if (!this.progress) return;
        this.progress.classList.remove('is-running');
        this.progress.style.setProperty('--dt-slider-duration', `${this.interval}ms`);
        void this.progress.offsetWidth;
        if (this.autoplay && !this.paused) this.progress.classList.add('is-running');
      }

      schedule() {
        window.clearTimeout(this.timer);
        if (!this.autoplay || this.paused) return;
        this.timer = window.setTimeout(() => {
          this.show(this.index + 1, false);
          this.schedule();
        }, this.interval);
      }

      pause() {
        this.paused = true;
        window.clearTimeout(this.timer);
        this.progress?.classList.remove('is-running');
      }

      resume() {
        this.paused = false;
        this.restartProgress();
        this.schedule();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
